module.exports = __webpack_public_path__ + "img/art-gallery.b53a18cb.png";